import React, { useState, useEffect } from "react";
import { sendApiRequest } from "../utils/api";

const ReportTranscriptionUserLists = () => {
  const [reports, setReports] = useState([]);

  const fetchUserReportTranscription = async () => {
    try {
      const response = await sendApiRequest("api/reports", {}, "GET");
      setReports(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
  };

  useEffect(() => {
    fetchUserReportTranscription();
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="p-6">
      {/* Page Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">
          Report Transcription User Lists
        </h1>

      </div>

      {/* Table */}
      <div className="overflow-x-auto shadow-lg rounded-xl border border-gray-200">
        <table className="w-full border-collapse">
          <thead className="bg-gray-100 border-b">
            <tr>
              <th className="p-3 text-left font-semibold text-gray-700">User</th>
              <th className="p-3 text-left font-semibold text-gray-700">Email</th>
              <th className="p-3 text-left font-semibold text-gray-700">Topic</th>
              <th className="p-3 text-left font-semibold text-gray-700">Reason</th>
              <th className="p-3 text-left font-semibold text-gray-700">Status</th>
              <th className="p-3 text-left font-semibold text-gray-700">Created At</th>
            </tr>
          </thead>

          <tbody>
            {reports.length > 0 ? (
              reports.map((item) => (
                <tr
                  key={item._id}
                  className="border-b hover:bg-gray-50 transition"
                >
                  <td className="p-3 text-gray-800">{item.user.name}</td>
                  <td className="p-3 text-gray-600">{item.user.email}</td>
                  <td className="p-3 text-gray-800">{item.topic.title}</td>
                  <td className="p-3 text-gray-600">{item.reason}</td>

                  <td className="p-3">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-semibold ${
                        item.status === "pending"
                          ? "bg-yellow-200 text-yellow-700"
                          : item.status === "resolved"
                          ? "bg-green-200 text-green-700"
                          : "bg-red-200 text-red-700"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td className="p-3 text-gray-600">
                    {new Date(item.createdAt).toLocaleString()}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center p-5 text-gray-600">
                  Loading or No Reports Found...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Print Styles */}
      <style>
        {`
          @media print {
            button {
              display: none;
            }
            body {
              background: white;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ReportTranscriptionUserLists;
